import { isMocking, mockedEvent, getMockSocket } from 'api/mockupUtils'
import PHASE from 'utils/constants/phases'
import DATA_INTRO from 'data/mocks/intro.json'
import DATA_PRE_SEASON from 'data/mocks/preSeason.json'
import DATA_PRE_RACE from 'data/mocks/preRace.json'
import DATA_RACE from 'data/mocks/race.json'
import DATA_POST_RACE from 'data/mocks/postRace.json'
import DATA_POST_SEASON from 'data/mocks/postSeason.json'

export default socket => ({
    sendSelection: data => {
        console.tron.log('SOCKET EMMIT - selection:')
        console.tron.log(data)
        if (isMocking && data.phase) {
            socket.emit(mockedEvent('selection'), getMockSocket('current_status', { ...getCurrentMockPhase(data.phase), finished: true }))
            socket.emit(mockedEvent('selection'), getMockSocket('current_status', { ...getNextMockPhase(data.phase), finished: false }, 5000))
        } else {
            socket.emit('selection', data)
        }
    },
    requestCurrentStatus: currentPhaseForMocking => {
        console.tron.log('SOCKET EMMIT - request_current_status')
        console.tron.log(currentPhaseForMocking)
        // socket.emit(mockedEvent('request_current_status'), isMocking ? getMockSocket('current_status', getCurrentMockPhase(currentPhaseForMocking)) : undefined)
        socket.emit('request_current_status')
    }
})

function getCurrentMockPhase(phase) {
    if (phase === PHASE.PRE_SEASON) return DATA_PRE_SEASON
    if (phase === PHASE.PRE_RACE) return DATA_PRE_RACE
    if (phase === PHASE.RACE) return DATA_RACE
    if (phase === PHASE.POST_RACE) return DATA_POST_RACE
    if (phase === PHASE.POST_SEASON) return DATA_POST_SEASON
    return DATA_INTRO
}
function getNextMockPhase(phase) {
    if (phase === PHASE.DATA_INTRO) return DATA_PRE_SEASON
    if (phase === PHASE.PRE_SEASON) return DATA_PRE_RACE
    if (phase === PHASE.PRE_RACE) return DATA_RACE
    if (phase === PHASE.RACE) return DATA_POST_RACE
    if (phase === PHASE.POST_RACE) return DATA_POST_SEASON
    return DATA_PRE_SEASON
}



// WEBPACK FOOTER //
// src/api/emitters/status.js